import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.promise.js";

/* eslint-disable no-console */
import axios from 'axios';
import { authorizeConfig } from 'utils'; // import qs from 'qs';

var getProperty = function getProperty(properties, object) {
  return properties.reduce(function (xs, x) {
    return xs && xs[x];
  }, object);
}; // axios.defaults.paramsSerializer = params => qs.stringify(params, { indices: false });


export var getReq = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url, config) {
    var keys,
        response,
        data,
        err,
        _args = arguments;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            keys = _args.length > 2 && _args[2] !== undefined ? _args[2] : [];
            _context.prev = 1;
            _context.next = 4;
            return axios.get(url, authorizeConfig(config));

          case 4:
            response = _context.sent;
            data = getProperty(['data'].concat(keys), response);
            return _context.abrupt("return", Promise.resolve([data, null, response.status, response.headers]));

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](1);
            err = _context.t0.response;
            console.log(err);
            return _context.abrupt("return", Promise.resolve([null, err, err === null || err === void 0 ? void 0 : err.status]));

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 9]]);
  }));

  return function getReq(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var deleteReq = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(url, config) {
    var keys,
        response,
        data,
        err,
        _args2 = arguments;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            keys = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : [];
            _context2.prev = 1;
            _context2.next = 4;
            return axios["delete"](url, authorizeConfig(config));

          case 4:
            response = _context2.sent;
            data = getProperty(['data'].concat(keys), response);
            return _context2.abrupt("return", Promise.resolve([data, null, response.status]));

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](1);
            err = _context2.t0.response;
            console.log(err);
            return _context2.abrupt("return", Promise.resolve([null, err, err === null || err === void 0 ? void 0 : err.status]));

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 9]]);
  }));

  return function deleteReq(_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();
export var postReq = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(url, body, config) {
    var keys,
        response,
        data,
        err,
        _args3 = arguments;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            keys = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : [];
            _context3.prev = 1;
            _context3.next = 4;
            return axios.post(url, body, authorizeConfig(config));

          case 4:
            response = _context3.sent;
            data = getProperty(['data'].concat(keys), response);
            return _context3.abrupt("return", Promise.resolve([data, null, response.status]));

          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](1);
            err = _context3.t0.response;
            console.log(err);
            return _context3.abrupt("return", Promise.resolve([null, err, err === null || err === void 0 ? void 0 : err.status]));

          case 14:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[1, 9]]);
  }));

  return function postReq(_x5, _x6, _x7) {
    return _ref5.apply(this, arguments);
  };
}();
export var putReq = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(url, body, config) {
    var keys,
        response,
        data,
        err,
        _args4 = arguments;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            keys = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : [];
            _context4.prev = 1;
            _context4.next = 4;
            return axios.put(url, body, authorizeConfig(config));

          case 4:
            response = _context4.sent;
            data = getProperty(['data'].concat(keys), response);
            return _context4.abrupt("return", Promise.resolve([data, null, response.status]));

          case 9:
            _context4.prev = 9;
            _context4.t0 = _context4["catch"](1);
            err = _context4.t0.response;
            console.log(err);
            return _context4.abrupt("return", Promise.resolve([null, err, err === null || err === void 0 ? void 0 : err.status]));

          case 14:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[1, 9]]);
  }));

  return function putReq(_x8, _x9, _x10) {
    return _ref7.apply(this, arguments);
  };
}();
export var patchReq = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(url, body, config) {
    var keys,
        response,
        data,
        err,
        _args5 = arguments;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            keys = _args5.length > 3 && _args5[3] !== undefined ? _args5[3] : [];
            _context5.prev = 1;
            _context5.next = 4;
            return axios.patch(url, body, authorizeConfig(config));

          case 4:
            response = _context5.sent;
            data = getProperty(['data'].concat(keys), response);
            return _context5.abrupt("return", Promise.resolve([data, null, response.status]));

          case 9:
            _context5.prev = 9;
            _context5.t0 = _context5["catch"](1);
            err = _context5.t0.response;
            console.log(err);
            return _context5.abrupt("return", Promise.resolve([null, err.response, err === null || err === void 0 ? void 0 : err.status]));

          case 14:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[1, 9]]);
  }));

  return function patchReq(_x11, _x12, _x13) {
    return _ref9.apply(this, arguments);
  };
}();
export var getConfig = function getConfig() {
  return axios.defaults;
};